/** 本のチャットと本棚全体への質問で共通の表示 */
import { Loader2 } from 'lucide-react'

import { SimpleMarkdown } from './simple-markdown'

/** 読者の質問の吹き出し */
export const UserBubble = ({ content }: { content: string }) => (
  <div className="flex justify-end">
    <p className="max-w-[85%] rounded-2xl rounded-br-sm bg-primary px-3 py-2 text-sm text-primary-foreground wrap-break-word whitespace-pre-wrap">
      {content}
    </p>
  </div>
)

/** 最初に出す質問の例（押すとそのまま質問する） */
export const SuggestionChips = ({
  intro,
  suggestions,
  onPick,
}: {
  intro: string
  suggestions: string[]
  onPick: (suggestion: string) => void
}) => (
  <div className="space-y-2 py-2">
    <p className="text-xs text-muted-foreground">{intro}</p>
    <div className="flex flex-wrap gap-1.5">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          type="button"
          className="rounded-full border px-3 py-1.5 text-xs hover:bg-muted"
          onClick={() => onPick(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  </div>
)

/** AI の答えの吹き出し（citations に根拠のボタン、children に追加の表示） */
export const AssistantBubble = ({
  content,
  citations,
  children,
}: {
  content: string
  citations?: React.ReactNode
  children?: React.ReactNode
}) => (
  <div className="space-y-2 rounded-2xl rounded-bl-sm bg-muted/60 px-3 py-2.5">
    <SimpleMarkdown text={content} />
    {citations && <div className="flex flex-wrap gap-1.5 border-t pt-2">{citations}</div>}
    {children}
  </div>
)

/** 答えを待っている間の表示 */
export const ThinkingIndicator = ({ label }: { label: string }) => (
  <div className="flex items-center gap-2 text-sm text-muted-foreground">
    <Loader2 className="size-4 animate-spin" />
    {label}
  </div>
)
